const logglyConfig = require('../loggly.json');

const env = process.env.NODE_ENV;
const basename = process.env.base;
const apiPort = 44351;

const urlParts = window.location.hostname.split('.');
const baseSiteUrl = env !== 'development' && urlParts != null && urlParts.length > 2
  ? `${ window.location.protocol }//${ urlParts.shift() }-api.${ urlParts.join('.') }`
  : 'http://localhost';
const getBaseApiUrl = () => {
  if (env === 'development') {
    return `https://localhost:${ apiPort }${ basename }api`;
  }
  return `${ baseSiteUrl }${ basename }api`;
};

const EnvConfig = {
  env,
  baseApiUrl: getBaseApiUrl(),
  cookieConsentName: 'tt_cc',
  eulaCookieName: 'tt_e',
  autentaLinkResendName: 'tt_ar',
  localeCookieName: 'tt_l',
  apiEndpoints: {
    authentaLink: '/auth/authentaLink',
    login: '/auth/login',
    logout: '/auth/logout',
    token: '/auth/token',
    forms: '/forms',
    language: '/language',
    config: '/config',
    auth: '/auth',
    validatePin: '/auth/validatePin',
    supportingDocuments: '/supportingdocuments',
    questionnaire: '/questionnaire',
    formGroups: '/formGroups',
  },
  showAnyError: env !== 'production',
  loggly: {
    enabled: env !== 'development',
    key: logglyConfig.key,
    src: logglyConfig.src
  }
};

export default EnvConfig;
